module.exports = "<pre><code class=\"hljs js\"><span class=hljs-keyword>import</span> Vue <span class=hljs-keyword>from</span> <span class=hljs-string>'vue'</span>;\n<span class=hljs-keyword>import</span> { FocusTrap } <span class=hljs-keyword>from</span> <span class=hljs-string>'@viafoura/vue-focus-trap'</span>;\n\nVue.component(<span class=hljs-string>'focus-trap'</span>, FocusTrap);\n</code></pre> ";


//////////////////
// WEBPACK FOOTER
// ./src-docs/app/snippets/installation-commonjs.md
// module id = 73
// module chunks = 1